































































































































































import Vue from "vue";
import { Auth, oAuth } from "../../../classes/Auth";
import { apiv1 } from "../../../libs/apiv1";
import moment from "moment";
import VueApexCharts from 'vue-apexcharts';
import VueAWN from "vue-awesome-notifications";
const auth = new Auth();

interface alert {
  id: number;
  carga_id: number;
  consumo_habil: number;// limite_superior
  consumo_no_habil: number;//
  meta_ahorro: number;
  limite_inferior: number;
  // periodicidad: string;
}
export default Vue.extend({
  name: "AlertsAdministration",
  data: () => ({
    type: false,
    dialog: false,
    valid: null,
    search: "",
    alert: {} as alert,
    headers: [
      { text: "Sucursal", value: "carga" },
      { text: "Consumo dia habil", value: "consumo_habil" },
      { text: "Consumo dia no habil", value: "consumo_no_habil" },
      { text: "Meta de ahorro", value: "meta_ahorro" },
      { text: "Limite minimo de consumo", value: "limite_inferior" },
      // { text: "Periodicidad", value: "periodicidad" },
      { text: "Acciones", value: "actions", sortable: false }
    ],
    puntos: [],
    alerts: [],
    // periodos: [
    //   { name: "diaria", value: "1 day" },
    //   { name: "semanal", value: "8 day" },
    //   { name: "mensual", value: "30 day" }
    // ],
    rules: {
      required: (value: any) => !!value || "Required."
    },
    loading: false
  }),
  async mounted() {
    await this.get_umbrales();
    this.get_cargas();
  },
  methods: {
    async closeDialog(evt: any) {
      this.dialog = false;
    },
    async get_umbrales() {
      this.loading = true;
      const { data } = await apiv1.get(
        `/umbrales?project=${oAuth.getProject().id}`
      );
      this.alerts = data;
      this.loading = false;
    },
    get_cargas() {
      apiv1
        .get(`cargas?project=${auth.getProject().id}`)
        .then(res => {
          this.puntos = res.data;
        })
        .catch(error => {
          VueAWN.alert(error.data);
        });
    },
    editItem(item: any) {
      this.alert.carga_id =  item.carga_id,
      this.alert.consumo_habil = item.consumo_habil;
      this.alert.consumo_no_habil = item.consumo_no_habil; 
      this.alert.meta_ahorro = item.meta_ahorro;
      this.alert.limite_inferior = item.limite_inferior;
      // this.alert.periodicidad = this.periodos.find(
      //   element => element.value == item.periodicidad.days + " day"
      // );
      this.alert.id = item.id;
      this.type = false;
      this.dialog = true;
    },
    deleteItem(item: any) {
      this.$swal({
        title: "Continuar?",
        text: `¿Seguro que desea eliminimar la alarma? '${item.carga}'?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, deseo eliminarlo",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          VueAWN.async(
            apiv1.delete(`/umbral/${item.id}`).then(res => {
              this.get_umbrales();
            })
          );
        }
      });
    },

    sendUmbral() {
      // this.alert.periodicidad = this.alert.periodicidad.value;
      this.alert.carga_id = this.alert.carga_id;
      if (this.type) {
        apiv1
          .post(`/umbrales`, this.alert)
          .then(res => {
            this.dialog = false;
            this.get_umbrales();
            VueAWN.success(res.data);
          })
          .catch(error => {
            VueAWN.alert(error.data);
          });
      } else {
        apiv1
          .put(`/umbral/${this.alert.id}`, this.alert)
          .then(res => {
            this.get_umbrales();
            this.dialog = false;
            VueAWN.success(res.data);
          })
          .catch(error => {
            VueAWN.alert(error.data);
          });
      }
    },
    createAlarm() {
      this.alert = {} as alert;
      this.type = true;
      this.dialog = true;
    }
  }
});
